










































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {dateTimeDisplay} from "@/lib/util/dateFunctions";
import {BaseScenarioType, IBaseScenario} from "@/lib/types/IBaseScenario";
import {agencyStore, designStore, lccaStore, projectStore, userStore} from "@/store/store";
import ErrorDisplay from "@/views/components/projects/ErrorDisplay.vue";
import {clearAllHttpErrors} from "@/lib/util/errors";
import {Route} from "vue-router";
import {acOverlayPages, asphaltPages, concretePages, porousPages} from "@/modules/design/designRouter";
import {lccaPages} from "@/modules/lcca/lccaRouter";
import {DesignScenarioType} from "@/modules/design/interfaces/shared";

@Component({
  name: 'InputPageWrapper',
  components: {ErrorDisplay}
})
export default class InputPageWrapper extends Vue {

  @Prop() readonly headerText!: string;
  @Prop() readonly page!: number;
  @Prop({default: false}) readonly last!: boolean;
  @Prop({default: true}) readonly showDefaultCardBody!: boolean;
  @Prop() scenario!: IBaseScenario;
  @Prop({default: null}) validations!: any;
  @Prop({default: () => []}) warnings!: string[];
  // @Prop() pages!: {link: string, text: string}[];


  dateDisplay = dateTimeDisplay;

  get lastModified() {
    // console.log(this.scenario);
    // console.log('type:',this.scenario.scenarioType);
    return this.scenario.modified
  }

  get httpErrors(){
    const e : any[] = [];
    return e.concat(designStore.httpErrors).concat(projectStore.httpErrors).push(userStore.httpErrors)
  }

  resetHttpErrors(){
    designStore.clearErrors();
    projectStore.clearErrors();
    userStore.clearErrors()
  }


  get scenarioTypeText() {
    if (this.scenario.scenarioType === BaseScenarioType.design) {
      //@ts-ignore
      return this.scenario.designScenarioType
    } else {
      switch (this.scenario.scenarioType) {
        case BaseScenarioType.lcca:
          return 'LCCA';
        case BaseScenarioType.agencyCost:
          return 'Agency Cost';
        case BaseScenarioType.perRoad:
          return 'PerRoad'
      }
    }
    return '[No scenario type found]'
  }

  get prevPage(): string {
    if (this.page > 1) {
      return (this.page - 1).toString()
    } else {
      return this.page.toString()
    }
  }

  get nextPage(): string {
    return (this.page + 1).toString()
  }

  get currentPageNum(){
    return Number(this.page)
  }

  get pages(): {link: string, text: string}[]{
    switch (this.scenario.scenarioType) {
      case BaseScenarioType.design:
        //@ts-ignore
        switch (this.scenario.designScenarioType){
          case DesignScenarioType.asphalt:
            return asphaltPages;
          case DesignScenarioType.concrete:
            return concretePages;
          case DesignScenarioType.porous:
            return porousPages;
          case DesignScenarioType.acOverlay:
            return acOverlayPages
        }
        break;

      case BaseScenarioType.lcca:
        return lccaPages;
      // case BaseScenarioType.agencyCost:
      //   return 'Agency Cost';
      // case BaseScenarioType.perRoad:
      //   return 'PerRoad'
    }
    return []
  }


  saveWarning: null | string = null;

  save() {
    this.$emit('sync');
    clearAllHttpErrors();
    this.$emit('save');
    if (this.validations !== null && this.validations !== undefined) {
      this.validations.$touch();
    }
    //   // if (!this.validations.$anyError) {
    //     this.saveWarning = null;
    //     // this.$emit('save');
    //     if (this.scenario.scenarioType === BaseScenarioType.design){
    //       designStore.saveCurrentScenario()
    //     } else if (this.scenario.scenarioType === BaseScenarioType.lcca){
    //       lccaStore.saveCurrentScenario()
    //     } else if (this.scenario.scenarioType === BaseScenarioType.agencyCost){
    //       agencyStore.saveCurrentScenario()
    //     } else {
    //       this.saveWarning = "No handler found for saving this scenario type."
    //     }
    //   // } else {
    //   //   this.saveWarning = "Check all inputs before saving."
    //   // }
    // } else {
    //   if (this.scenario.scenarioType === BaseScenarioType.lcca){
    //     lccaStore.saveCurrentScenario()
    //   }
    //   this.$emit('save');
    // }
  }


  // get saveButtonDisabled(): boolean{
  //   // Don't allow clicking "save" unless there's data to save!
  //   if (this.validations !== null && this.validations !== undefined) {
  //     return !this.validations.$anyDirty
  //   }
  //   return false
  // }

  created() {
    this.saveWarning = null;
    this.resetHttpErrors()
  }

}
